<template>
    <div id="securityInformationTrafficSupport">
        <div class="container">
            <div class="row m-0 pl-md-5 pr-md-5">
                <div class="col-lg-6 text-center mb-5">
                    <img src="@/assets/traffic-600.webp" class="img-fluid" alt="Azurity Beveiliging" />
                </div>
                <div class="col-lg-6 text-left ">
                    <h1 class="pt-5 pb-5">Verkeersdiensten</h1>
                    <h3><span class="text-muted">Vind bij Azurity de juiste verkeersoplossing voor elke klus.</span></h3>
                    <div class="row mt-5">
                        <div class="col-md-12 mb-5">
                            <ul class="mb-5">
                                <li>
                                    <strong>Verkeersregelaars</strong>
                                    <p>Een verkeersregelaar is in Nederland een persoon die de bevoegdheid heeft om instructies op te dragen aan weggebruikers, zoals bepaald in het Reglement verkeersregels en verkeerstekens.</p>
                                    <p>Een evenementenverkeersregelaar krijgt een instructie via e-learning, en mag hiermee enkel voor de aangewezen dagen tijdens het evenement het verkeer regelen conform de taakinstructie van de organisator.</p>
                                </li>
                            </ul>
                            <register-buttons :sidebyside="false" type="verkeersregelaar"></register-buttons>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegisterButtons from '@/components/RegisterButtons';
export default {
    components: {
        RegisterButtons
    }
}
</script>

<style scoped>
</style>